export default "__VITE_PUBLIC_ASSET__93139d50__"